import { ArticleMedia } from '@browsing/components';
import { NavigationSourceType, CatalogType } from '@browsing/utils';

export enum StockStatus {
    RESERVED = 'RESERVED',
    SOLD_OUT = 'SOLD_OUT',
    AVAILABLE = 'AVAILABLE',
}

export interface ContinueShoppingCardItem {
    brand: string;
    campaignIdentifier: string;
    media: ArticleMedia[];
    nameCategoryTag: string;
    nameColor: string;
    nameShop: string;
    price: number;
    sku: string;
    specialPrice: number | null;
    navigationSource: NavigationSourceType;
    catalogType: CatalogType;
    sustainable: boolean;
    stockStatus: StockStatus;
    plusEarlyAccess: boolean;
    withPrimaryColor: boolean;
    hasSimilar: boolean;
    urlPath: { [key: string]: string };
    similarPrices: boolean;
    hasTestMedia: boolean;
}

export interface ContinueShoppingCategory {
    categoryId: number;
    categoryName: string;
    hasMore: boolean;
    configs: ContinueShoppingCardItem[];
}

export type ContinueShoppingDataType = ContinueShoppingCategory[];

// Internal helper types
export interface TrackingItemType {
    sku: string;
    brandCode: string;
    campaignIdentifier: string;
    price: number;
    specialPrice: number | null;
    stockStatus: StockStatus;
    plusEarlyAccess: boolean;
    sustainable: boolean;
    categoryId: null;
    simples: never[];
}

export interface PreparedDataType {
    panelData: Array<{
        category: ContinueShoppingCategory;
        shouldShowSeeAll: boolean;
        categoriesList: ContinueShoppingCardItem[];
    }>;
    trackingItems: TrackingItemType[];
}
